/* eslint no-useless-escape: 0 */
import Synonyms from '../config/Synonyms'
import ignoreCases from '../config/ignoreCases'

const getIgnoreCases = regexType => {
    const contractions =
        ignoreCases[`${regexType}Regex`] &&
        ignoreCases[`${regexType}Regex`].contractions
            ? ignoreCases[`${regexType}Regex`].contractions
            : []
    const sentences =
        ignoreCases[`${regexType}Regex`] &&
        ignoreCases[`${regexType}Regex`].sentences
            ? ignoreCases[`${regexType}Regex`].sentences
            : []

    const ignoreContractions = `${
        contractions.length ? `\\B${contractions.join('\\b|\\B')}\\b|` : ''
    }`
    const ignoreSentences = `${
        sentences.length ? `\\b${sentences.join('\\b|\\b')}\\b|` : ''
    }`

    return `${ignoreContractions}${ignoreSentences}`
}


const terms = { masculine: [], feminine: [] }
const regex = {
    bullshitRegex: new RegExp(
        `${getIgnoreCases(
            'bullshit',
        )}\\b(touch base|bandwidth|going forward|synergy|paradigm\Wshift|outside\Wthe\Wbox|blue\Wsky\Wthinking|ducks\Win\Wa\Wrow|pushing the envelope|joined\Wup\Wthinking|low\Whanging\Wfruit|floating an idea|unique selling point|leverage|state\Wof\Wthe\Wart|ground\Wbreaking|circle back|reach out|boil the ocean|at the end of the day|move the needle|game\Wchanger|game\Wchanging|right\Wsizing|value\Wadded|value\Wadd|mission\Wcritical)\\b`,
        'ig',
    ),
    mustRegex: new RegExp(
        `${getIgnoreCases(
            'must',
        )}\\b(must|required|requirements|requirement|desirable|essential|need to have|needs to have)\\b`,
        'ig',
    ),
    // experienceRegex : /\b(([\d+-]+\s)+(or more|plus)?(\s)*years|experienced|experience|experience\s|experience\W(working\W)?(with|in|of|at)?|proven\Wtrack\Wrecord|track\Wrecord)\b/ig,
    // educationRegex : /\b(top university|selective university|(1st|first|2nd|second) class degree|(honours|honors)?(degree|masters|bachelors|PHD|MBA))?\b/ig
}

Object.keys(Synonyms).forEach(term => {
    if (!terms[Synonyms[term].type]) terms[Synonyms[term].type] = []
    terms[Synonyms[term].type].push(term.replace(/\s/gi, '\\W'))
})

Object.keys(terms).forEach(type => {
    regex[`${type}Regex`] = new RegExp(
        `${getIgnoreCases(type)}\\b(${terms[type].join('|')})\\b`,
        'ig',
    )
})

export default regex
